export const clearCookies = () => {
	const cookies = document.cookie.split(';');
	for (let i=0, l=cookies.length; i<l; ++i) {
		const cookie = cookies[i];
		const eq = cookie.indexOf('=');
		const name = eq > -1 ? cookie.substr(0, eq) : cookie;
		document.cookie = `${name}=;expires=Thur, 01 Jan 1970 00:00:00 GMT`;
	}
}